const actionTypesPrefix = "EXTENSIONS";
const extensionsConstants = {
  SET_PARTIAL_USER_CONTEXT: "EXTENSIONS/SET_PARTIAL_CONTEXT",
  SET_USER_CONTEXT: "EXTENSIONS/SET_CONTEXT",
  LOAD: "EXTENSIONS/LOAD",
  LOADING: "EXTENSIONS/LOADING",
  LOADED: "EXTENSIONS/LOADED",
  AGGREGATE: "Aggregate",
  STANDARD: "Standard"
};
const segmentConstants = {};
export {
  extensionsConstants as default
};
//# sourceMappingURL=ExtensionsConstants.js.map
